<template>
  <div>
    <div class="banner for-mobile-banner">
      <b-carousel
        id="carousel-1"
        :interval="3000"
        :controls="controls"
        :img-height="imgHeight || ''"
        :img-width="imgWidth || ''"
        :background="background"
        style="text-shadow: 1px 1px 2px #aaa"
      >
        <a
          :href="ad.link"
          :target="ad.target"
          v-for="(ad, index) in banners"
          :key="index"
        >
          <b-carousel-slide
            :class="$route.name === 'PublicEvents' ? 'event-banner' : ''"
            :style="imgWidth ? imgSize : ''"
            :img-src="ad.banner"
          >
          </b-carousel-slide>
        </a>
      </b-carousel>
    </div>
  </div>
</template>


<script>
export default {
  name: 'Advertisement',
  props: {
    banners: { type: Array, default: () => [] },
    imgWidth: { type: String, default: '100%' },
    imgHeight: { type: String, default: '100%' },
    controls: { type: Boolean, default: false },
    background: { type: String, default: '#aaaaaa' },
  },
  computed: {
    imgSize() {
      return {
        width: `${this.imgWidth}`,
        height: `${this.imgHeight}`,
      };
    },
  },
};
</script>

<style scoped>
.banner {
  margin: 0;
  background-color: #666666;
  text-align: center;
  color: aliceblue;
}
.banner, .banner .carousel, .banner .carousel .carousel-inner {
  border-radius: 0 10px 10px 10px !important;
}

.banner .carousel .carousel-inner {
  width: 100% !important;
  height: 100% !important;
}
.banner, .banner .carousel, .banner .carousel .carousel-inner {
  border-radius: 0 10px 10px 10px !important;
}

.banner .carousel .carousel-inner {
  width: 100% !important;
  height: 100% !important;
}

.event-banner >>> img {
  object-fit: cover;
  height: auto;
}

#carousel-1 .carousel-item {
  width: 100% 100% !important;
  height: auto !important;
}

@media (max-width: 1024px) {
  .for-mobile-banner
    >>> #carousel-1
    > .carousel-inner
    > a
    > .carousel-item
    > img {
    max-height: 60px;
    max-width: 100%;
    object-fit: contain;
  }
.event-banner{
  height: 300px !important;
}
  .event-banner >>> img {
    height: 300px;
  }
}
</style>
